/** @format */
import React, { useState, useEffect } from "react";
import { Link } from "react-scroll";
import MobileHeader from "./MobileHeader";

export const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [bgColor, setBgColor] = useState("bg-transparent"); // État pour la couleur de fond

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 150) {
        setBgColor("bg-white");
      } else {
        setBgColor("bg-transparent");
      }
    };
    // Ajoutez un écouteur d'événements pour la détection du défilement
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 ${bgColor} text-black p-4 md:p-8 font-bold transition-colors duration-300`}
    >
      <div className="flex justify-center items-center mx-auto max-w-screen-lg">
        {/* Logo */}
        {/* Menu pour les grands écrans */}
        <div className="hidden md:flex items-center space-x-6">
          <Link
            to="home"
            smooth={true}
            duration={500}
            className="cursor-pointer hover:text-green-800 transition duration-150 ease-in-out"
          >
            Home
          </Link>
          <Link
            to="presentation"
            smooth={true}
            duration={500}
            className="cursor-pointer hover:text-green-800 transition duration-150 ease-in-out"
          >
            Présentation
          </Link>
          <Link
            to="galeries"
            smooth={true}
            duration={500}
            className="cursor-pointer hover:text-green-800 transition duration-150 ease-in-out"
          >
            Galerie
          </Link>

          <Link
            to="telechargements"
            smooth={true}
            duration={500}
            className="cursor-pointer hover:text-green-800 transition duration-150 ease-in-out"
          >
            Téléchargement
          </Link>
          <Link
            to="contact"
            smooth={true}
            duration={500}
            className="cursor-pointer hover:text-green-800 transition duration-150 ease-in-out"
          >
            Contact
          </Link>
        </div>

        {/* Icône de menu pour les petits écrans */}
      </div>

      {/* Menu mobile */}
      <MobileHeader menuOpen={menuOpen} toggleMenu={toggleMenu} />
    </header>
  );
};
